import * as React from "react";
import { usePostHog } from "@posthog/react";
import { useState, useEffect } from "react";

const ENGLISH_TRANSLATIONS = {
  message: "We use cookies to improve your experience and analyze our website.",
  privacyLink: "Privacy Policy",
  privacyHref: "/en/privacy",
  decline: "Decline",
  accept: "Accept",
};

const GERMAN_TRANSLATIONS = {
  message:
    "Wir verwenden Cookies, um Ihre Erfahrung zu verbessern und unsere Website zu analysieren.",
  privacyLink: "Datenschutzerklärung",
  privacyHref: "/privacy",
  decline: "Ablehnen",
  accept: "Akzeptieren",
};

type ConsentStatus = "pending" | "granted" | "denied" | undefined;

export function PrivacyNoticeBanner() {
  const language: "en" | "de" =
    typeof window !== "undefined" && window.location.pathname.startsWith("/de")
      ? "de"
      : "en";
  const translations =
    language === "de" ? GERMAN_TRANSLATIONS : ENGLISH_TRANSLATIONS;
  const posthog = usePostHog();
  const [consentStatus, setConsentStatus] = useState<ConsentStatus>(undefined);

  useEffect(() => {
    if (posthog) {
      const status = posthog.get_explicit_consent_status();
      setConsentStatus(status);
    }
  }, [posthog]);

  const handleAccept = () => {
    if (posthog) {
      posthog.opt_in_capturing();
      setConsentStatus("granted");
    }
  };

  const handleDecline = () => {
    if (posthog) {
      posthog.opt_out_capturing();
      setConsentStatus("denied");
    }
  };

  if (consentStatus !== "pending") {
    return null;
  }

  return (
    <div className="sticky bottom-0 border-t bg-color-2 px-4 py-6 text-color-2-text sm:px-6">
      <div className="max-w-screen-lg mx-auto flex flex-col sm:flex-row items-center sm:items-center justify-between gap-4">
        <p className="text-sm text-center sm:text-left">
          {translations.message}{" "}
          <a
            href={translations.privacyHref}
            className="underline text-color-2-text-primary"
          >
            {translations.privacyLink}
          </a>
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={handleDecline}
            className="px-4 py-2 text-sm border border-color-2-text rounded hover:bg-color-2-text hover:text-color-2 transition-colors"
          >
            {translations.decline}
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 text-sm bg-primary text-primary-text rounded hover:opacity-90 transition-opacity"
          >
            {translations.accept}
          </button>
        </div>
      </div>
    </div>
  );
}
